import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowStretchBox24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconArrowStretchBox24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 5.5h14A1.5 1.5 0 0 1 20.5 7v10a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 17V7A1.5 1.5 0 0 1 5 5.5M2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm6.802 5.75 1.557 1.556a.75.75 0 0 1-1.061 1.061L6.47 12.54l-.53-.53.467-.469a.8.8 0 0 1 .134-.133L9.298 8.65a.75.75 0 0 1 1.06 1.06L8.82 11.25h6.367L13.64 9.703a.75.75 0 1 1 1.06-1.06l2.787 2.787q.045.038.083.083l.489.489-.522.521-.014.014L14.7 15.36a.75.75 0 0 1-1.06-1.06l1.55-1.55z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowStretchBox24);
